import React from 'react';

export default function SkeletonCard() {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-2xl p-4 animate-pulse">
      <div className="flex items-center gap-3">
        <div className="w-12 h-12 rounded-xl skeleton" />
        <div className="flex-1">
          <div className="h-4 w-24 rounded skeleton mb-2" />
          <div className="h-3 w-16 rounded skeleton" />
        </div>
        <div className="w-10 h-10 rounded-full skeleton" />
      </div>
    </div>
  );
}

export function SkeletonDashboard() {
  return (
    <div className="space-y-4 p-4">
      <div className="h-32 rounded-2xl skeleton" />
      <div className="h-4 w-32 rounded skeleton" />
      {[1, 2, 3].map((i) => (
        <SkeletonCard key={i} />
      ))}
    </div>
  );
}
